
export const MASTER_DATA_UNIVERSITIES_LOADING = "MASTER_DATA_UNIVERSITIES_LOADING";
export const MASTER_DATA_UNIVERSITIES_SUCCESS = "MASTER_DATA_UNIVERSITIES_SUCCESS";
export const MASTER_DATA_UNIVERSITIES_FAILED = "MASTER_DATA_UNIVERSITIES_FAILED";


export const DIGILOCKER_GET_URL_LOADING = "DIGILOCKER_GET_URL_LOADING";
export const DIGILOCKER_GET_URL_SUCCESS = "DIGILOCKER_GET_URL_SUCCESS";
export const DIGILOCKER_GET_URL_FAILED = "DIGILOCKER_GET_URL_FAILED";


export const DIGILOCKER_RESPONSE_LOADING = "DIGILOCKER_RESPONSE_LOADING";
export const DIGILOCKER_RESPONSE_SUCCESS = "DIGILOCKER_RESPONSE_SUCCESS";
export const DIGILOCKER_RESPONSE_FAILED = "DIGILOCKER_RESPONSE_FAILED";


export const DIGILOCKER_DATA_RESPONSE_LOADING = "DIGILOCKER_DATA_RESPONSE_LOADING";
export const DIGILOCKER_DATA_RESPONSE_SUCCESS = "DIGILOCKER_DATA_RESPONSE_SUCCESS";
export const DIGILOCKER_DATA_RESPONSE_FAILED = "DIGILOCKER_DATA_RESPONSE_FAILED";


export const CHECK_DOC_RESPONSE_LOADING = "CHECK_DOC_RESPONSE_LOADING";
export const CHECK_DOC_RESPONSE_SUCCESS = "CHECK_DOC_RESPONSE_SUCCESS";
export const CHECK_DOC_RESPONSE_FAILED = "CHECK_DOC_RESPONSE_FAILED";


export const UPLOAD_DIGI_DOC_LOADING = "UPLOAD_DIGI_DOC_LOADING";
export const UPLOAD_DIGI_DOC_SUCCESS = "UPLOAD_DIGI_DOC_SUCCESS";
export const UPLOAD_DIGI_DOC_FAILED = "UPLOAD_DIGI_DOC_FAILED";


export const REMOVE_FILE_LOADING = "REMOVE_FILE_LOADING";
export const  REMOVE_FILE_SUCCESS = "REMOVE_FILE_SUCCESS";
export const  REMOVE_FILE_FAILED = "REMOVE_FILE_FAILED";


export const SAVE_REASON_LOADING = "SAVE_REASON_LOADING";
export const  SAVE_REASON_SUCCESS = "SAVE_REASON_SUCCESS";
export const  SAVE_REASON_FAILED = "SAVE_REASON_FAILED";

export const RETRY_DIGILOCKER_LOADING = "RETRY_DIGILOCKER_LOADING";
export const  RETRY_DIGILOCKER_SUCCESS = "RETRY_DIGILOCKER_SUCCESS";
export const  RETRY_DIGILOCKER_FAILED = "RETRY_DIGILOCKER_FAILED";